// extracted by mini-css-extract-plugin
export default {"cell":"SortableTable_cell__0JXB-","grid":"SortableTable_grid__vTUeL","header":"SortableTable_header__0-UOL SortableTable_cell__0JXB-"};